import { FunctionComponent } from 'react'
import { AppDropdownButton } from '@/shared/ui'
import { CaretDownIcon } from '@phosphor-icons/react'

export type Option = {
  label?: string
  value?: string
}

export type DropdownSelectProps = {
  buttonText?: string
  options?: Option[]
  selectedOption?: string
  onChangeSelectedOption?: (option: string) => void
  className?: string
}

export const DropdownSelect: FunctionComponent<DropdownSelectProps> = ({
  buttonText = 'Editar en lote',
  options = [
    {
      label: 'Agregar cupos',
      value: '1'
    },
    {
      label: 'Remover cupos',
      value: '2'
    }
  ],
  selectedOption = '',
  onChangeSelectedOption = () => {},
  className = ''
}: DropdownSelectProps): JSX.Element => {
  const getItemsList = () => {
    return (
      <div className='gungnir-ds-options-list'>
        {options.map(({ label, value }, idx) => {
          const id = String(value)
          return (
            <div
              className={`gungnir-ds-option ${selectedOption === id ? 'selected' : ''}`}
              onClick={() => onChangeSelectedOption(id)}
              key={idx}
              id={id}
            >
              <span>{label}</span>
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <div data-testid='gungnir-ds' className={`gungnir-ds ${className}`}>
      <AppDropdownButton trigger={['click']} overlay={getItemsList()} icon={<CaretDownIcon />}>
        {buttonText}
      </AppDropdownButton>
    </div>
  )
}
